export const PTT_BRIDGE_CHANNEL = 'cwy-ptt-v1';
export const PTT_AUDIO_LEADER_KEY = 'cwy-ptt-audio-leader';

export type PttBridgeMessage =
  | {
      type: 'PTT_START';
      channel_id: string;
      user_id: string;
      display_name: string;
      sample_rate: number;
      source_tab_id: string;
    }
  | {
      type: 'PTT_CHUNK';
      channel_id: string;
      user_id: string;
      chunk: string;
      seq: number;
      source_tab_id: string;
    }
  | {
      type: 'PTT_END';
      channel_id: string;
      user_id: string;
      source_tab_id: string;
    }
  | { type: 'PTT_PHONE_READY'; source_tab_id: string };

export type PttSpeaker = {
  user_id: string;
  display_name: string;
  channel_id: string;
};

export type GlobalPttState = {
  remoteSpeaker: PttSpeaker | null;
  isReceiving: boolean;
  isPlayingLocally: boolean;
  isTransmitting: boolean;
  transmitChannelId: string | null;
  micError: string | null;
};
